import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useApi } from "@/lib/api";

const SHORT = { bdq: "BDQ", skda: "SKDA", hte: "HTE", kbm: "KBM", adab: "ADAB" };

export const ChainCrumbs = ({ kajianId }) => {
  const api = useApi();
  const [items, setItems] = useState([]);
  useEffect(() => { api("get", `/kajian/${kajianId}/chain`).then(setItems).catch(() => {}); }, [api, kajianId]);
  if (items.length < 2) return null;
  return (
    <nav aria-label="Rantaian kajian" className="flex flex-wrap items-center gap-1.5 text-sm" data-testid="chain-breadcrumbs">
      {items.map((k, i) => (
        <span key={k.id} className="inline-flex items-center gap-1.5">
          {i > 0 && <ChevronRight size={14} className="text-mute" />}
          {k.id === kajianId ? <span className="text-ink font-semibold">{SHORT[k.skill]} {k.tajuk || k.isu || k.rujukan}</span> :
            <Link to={`/kajian/${k.id}`} className="text-mute hover:text-ink" data-testid={`chain-link-${k.id}`}>{SHORT[k.skill]} {k.tajuk || k.isu || k.rujukan}</Link>}
        </span>
      ))}
    </nav>
  );
};

